import React from "react";

function UpdateWarning() {
  return (
    <div className="d-flex flex-column justify-content-center ml-2 mt-2 mr-2 mb-6 align-items-center">
      <p className="m-0 p-0">
        Updating for all will reset the approval process for all
      </p>
      <p className="m-0 p-0">on-going and pending approvals.</p>
    </div>
  );
}
export default UpdateWarning;
